import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea, Link } from '@mui/material';

function MediaCard({ image, children, cardWidth, cardHeight, redirectPage }) {
  return (
    <Card sx={{ width: cardWidth, borderRadius: 5 }}>
      {redirectPage ? (
        <CardActionArea component={Link} href={redirectPage} target="_blank">
          <CardMedia component="img" height={cardHeight} image={image} alt="" />
          {children}
        </CardActionArea>
      ) : (
        <>
          <CardMedia component="img" height={cardHeight} image={image} alt="" />
          {children}
        </>
      )}
    </Card>
  );
}

MediaCard.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  cardWidth: PropTypes.number,
  cardHeight: PropTypes.number,
  redirectPage: PropTypes.string,
};

MediaCard.defaultProps = {
  cardWidth: 225,
  cardHeight: 230,
  redirectPage: null,
};

export default MediaCard;
